import { SceneContainer } from "GameObjects/StoryGame/SceneContainer";
import { SceneDraggable } from "GameObjects/StoryGame/SceneDraggable";
import { SceneSprite } from "GameObjects/StoryGame/SceneSprite";
import { Elastic, TimelineLite, TweenLite, TweenMax, RoughEase, TimelineMax, Expo } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "Singletons/Application";
import { AbstractStoryState } from "States/AbstractStoryState";
import { list, Mix } from "Utils/Reflection";

import {ch1_p010} from "../../../layouts/ch1_p10/ch1_p010";

export class Chapter1Page10 extends AbstractStoryState {

	readonly background = this.addChild(new SceneSprite());
	readonly lines = this.addChild(new SceneSprite());
	readonly arm = this.addChild(new SceneSprite());
	readonly phone = this.addChild(new SceneSprite());
	readonly handFront = this.addChild(new SceneSprite());
	readonly frame = this.addChild(new SceneSprite());

	protected phoneTimeline?: TimelineMax;

    public init(pSize: PIXI.Point, pData: any) {
        // exported layout from Animate CC
        ch1_p010.call(this);

		// interaction
		this.phone.interactive = true;
		this.phone.buttonMode = true;
		this.phone.accessible = true;
		this.phone.addListener(HLF.Input.Events.POINTER_TAP, ()=>{
			this.phoneTimeline?.kill();
			this.gotoNextState();
		});
		this.phone.position.y -= 4;

		// super.init calls onResize
		super.init(pSize, pData);
	}

	public animateIn(pOnComplete: ()=>void) {
		super.animateIn(pOnComplete);
		this.phoneTimeline = new TimelineMax();
		this.phoneTimeline
			.to(this.lines, 0.75, {pixi: {scale: this.lines.scale.x * 1.1, alpha: 0}}, 0)
			.to(this.phone, 1, {pixi: {
				x: this.phone.x + 4,
			}, ease: new RoughEase({
				taper: 'none',
				points: 200,
				strength: 2,
				randomize: false,
			})}, 0);
		this.phoneTimeline.repeat(-1).repeatDelay(1);

		// this.showHint({x: 1000, y: 400}, "hand", 1.5);
	}

	public animateOut(pOnComplete: ()=>void) {
		super.animateOut(pOnComplete);
		HLF.Application.instance.audio.stop("HollyPhoneVibrate", HLF.AudioCategory.SFX);
	}
}